import { __extends } from "tslib";
import React from 'react';
import { Component } from 'react';
import { CardActionButton } from './styled';
var CardActionIconButton = /** @class */ (function (_super) {
    __extends(CardActionIconButton, _super);
    function CardActionIconButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // this is to prevent currently focused text to loose cursor on clicking card action
        // this does not prevent onclick behavior
        _this.onMouseDown = function (event) {
            event.preventDefault();
        };
        return _this;
    }
    CardActionIconButton.prototype.render = function () {
        var _a = this.props, icon = _a.icon, triggerColor = _a.triggerColor, onClick = _a.onClick;
        return (React.createElement(CardActionButton, { "data-testid": "media-card-primary-action", onClick: onClick, onMouseDown: this.onMouseDown, style: { color: triggerColor } }, icon));
    };
    return CardActionIconButton;
}(Component));
export { CardActionIconButton };
//# sourceMappingURL=cardActionIconButton.js.map